import { render, staticRenderFns } from "./department_edit.vue?vue&type=template&id=68acfb00&scoped=true"
import script from "./department_edit.vue?vue&type=script&lang=js"
export * from "./department_edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68acfb00",
  null
  
)

export default component.exports